export class PageHandler {
    constructor(id) {
        this.id = id;
    }

    init() {
		
    }

    destroy() {

    }

	events() {
		
	}

	transitions() {

	}
}